jQuery(document).ready(function(e) {
	console.log('mix and match');


	function initCampaignCycle() {
        var width = $(document).width(); // Getting the width and checking my layout

  //       $('.campaign_slider').on('cycle-initialized', function( event, opts ) {
  //            $('.campaign_slider .campaign_slide:eq(' + (opts.currSlide + 1) + ')').addClass('central-active');
		// });

  //       $('.campaign_slider_2').on('cycle-initialized', function( event, opts ) {
  //            $('.campaign_slider_2 .campaign_slide:eq(' + (opts.currSlide + 1) + ')').addClass('central-active');
  //       });

  //       $('.campaign_slider').on('cycle-before', function( event, opts ) {
  //            console.log(opts.currSlide);
  //            console.log(opts.nextSlide);


  //            $('.campaign_slider .campaign_slide:eq(' + (opts.nextSlide + 1) + ')').addClass('central-active');
             
  //       });

  //       $('.campaign_slider_2').on('cycle-before', function( event, opts ) {
  //            console.log(opts.currSlide);
  //            console.log(opts.nextSlide);

  //            $('.campaign_slider_2 .campaign_slide:eq(' + (opts.currSlide + 1) + ')').removeClass('central-active');
  //            $('.campaign_slider_2 .campaign_slide:eq(' + (opts.nextSlide + 1) + ')').addClass('central-active');
  //       });



        $('.campaign_slider').cycle({
            fx: 'carousel',
            swipe: true,
            speed: 500,
            manualSpeed: 800,
            slides: '> .campaign_slide',
            next: '#next',
            prev: '#prev',
            carouselVisible: 3,
            timeout: 0,
            carouselFluid: true,
            easing : 'easeOutQuint',
            startingSlide: 0,
            log: false
        });

         $('.campaign_slider_2').cycle({
            fx: 'carousel',
            swipe: true,
            speed: 500,
            manualSpeed: 800,
            slides: '> .campaign_slide',
            next: '#next_2',
            prev: '#prev_2',
            carouselVisible: 3,
            timeout: 0,
            carouselFluid: true,
            easing : 'easeOutQuint',
            startingSlide: 0,
            log: false
        });

        


        


        // if ( width < 641 ) {
        //     $('.campaign_slider').cycle({
        //         fx: 'carousel',
        //         swipe: true,
        //         speed: 500,
        //         manualSpeed: 800,
        //         slides: '> .campaign_slide',
        //         next: '#next',
        //         prev: '#prev',
        //         carouselVisible: 3,
        //         timeout: 0,
        //         carouselFluid: true,
        //         easing : 'easeOutQuint'
        //     });
        //     // console.log('Init Mobile');
        // } else {
        //     $('.campaign_slider').cycle({
        //         fx: 'carousel',
        //         swipe: true,
        //         speed: 500,
        //         manualSpeed: 800,
        //         slides: '> .campaign_slide',
        //         next: '#next',
        //         prev: '#prev',
        //         carouselVisible: 3,
        //         timeout: 0,
        //         carouselFluid: true,
        //         easing : 'easeOutQuint'
        //     });
        // }

        // if ( width < 641 ) {
        //     $('.campaign_slider_2').cycle({
        //         fx: 'carousel',
        //         swipe: true,
        //         speed: 500,
        //         manualSpeed: 800,
        //         slides: '> .campaign_slide',
        //         next: '#next_2',
        //         prev: '#prev_2',
        //         carouselVisible: 3,
        //         timeout: 0,
        //         carouselFluid: true,
        //         easing : 'easeOutQuint'
        //     });
        //     // console.log('Init Mobile');
        // } else {
        //     $('.campaign_slider_2').cycle({
        //         fx: 'carousel',
        //         swipe: true,
        //         speed: 500,
        //         manualSpeed: 800,
        //         slides: '> .campaign_slide',
        //         next: '#next_2',
        //         prev: '#prev_2',
        //         carouselVisible: 3,
        //         timeout: 0,
        //         carouselFluid: true,
        //         easing : 'easeOutQuint'
        //     });
        // }

    }

    if($('.campaign_slider').length) {
        initCampaignCycle();
    }

    // function reinit_campaign_cycle() {
    //     var width = $(window).width(); // Checking size again after window resize

    //     if ( width < 641 ) {
    //         $('.campaign_slider').cycle('destroy');
    //         $('.campaign_slider_2').cycle('destroy');
    //         reinitCampaignCycle(1);
    //     } else {
    //         $('.campaign_slider').cycle('destroy');
    //         $('.campaign_slider_2').cycle('destroy');
    //         reinitCampaignCycle(3);
    //     }
    // }

    // function reinitCampaignCycle(visibleSlides) {
    //     $('.campaign_slider').cycle({
    //         fx: 'carousel',
    //         swipe: true,
    //         speed: 500,
    //         manualSpeed: 800,
    //         slides: '> .campaign_slide',
    //         next: '#next',
    //         prev: '#prev',
    //         carouselVisible: visibleSlides,
    //         timeout: 0,
    //         carouselFluid: true,
    //         easing : 'easeOutQuint'
    //     });

    //     $('.campaign_slider_2').cycle({
    //         fx: 'carousel',
    //         swipe: true,
    //         speed: 500,
    //         manualSpeed: 800,
    //         slides: '> .campaign_slide',
    //         next: '#next_2',
    //         prev: '#prev_2',
    //         carouselVisible: visibleSlides,
    //         timeout: 0,
    //         carouselFluid: true,
    //         easing : 'easeOutQuint'
    //     });

    // }

    // var reinitcampaignimer;
    // $(window).resize(function() {
    //     clearTimeout(reinitcampaignimer);
    //     reinitcampaignimer = setTimeout(reinit_campaign_cycle, 1000); // Timeout limits the number of calculations   
    // });


});
